import * as type from '../actions/types';

const initialState = {
  data: [],
  fetching: false,
  error: false,
  errorMessage: '',
  once: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case type.FETCH_RESTAURANTS_PENDING: {
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: false,
      };
    }

    case type.FETCH_RESTAURANTS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        fetching: false,
        error: false,
        errorMessage: '',
        once: true,
      };
    }

    case type.FETCH_RESTAURANTS_FAILURE: {
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };
    }

    default: {
      return state;
    }
  }
}
